import type { BuildingEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { ConditionOperator } from "./conditionTypes";
import { ComparisonOperators, EqualityOperators } from "./conditionTypes";

export const DocEntityFields = ["verticalOffset", "entityType", "entityLevel"] as const;
export type DocEntityField = (typeof DocEntityFields)[number];

export interface DocEntityFieldTypeDef {
  readonly entityType: "ENTITY_FIELD";
  readonly id: DocEntityField;
}

export const DocEntityFieldTypeDefAllowedEntityTypes: {
  [key in DocEntityField]: BuildingEntityType[];
} = {
  verticalOffset: ["PROP"],
  entityLevel: ["PROP"],
  entityType: ["PROP", "ANNOTATION", "CEILING"],
};

export const DocEntityFieldTypeDefDefaultValues: {
  [key in DocEntityField]: string | number;
} = {
  verticalOffset: 0,
  entityLevel: "",
  entityType: "ANNOTATION",
};

export const DocEntityFieldTypeDefOperators: {
  [key in DocEntityField]: readonly ConditionOperator[];
} = {
  verticalOffset: ComparisonOperators,
  entityLevel: EqualityOperators,
  entityType: EqualityOperators,
};

export type DocEntityFieldTypeDefTable = {
  readonly [key in DocEntityField]?: DocEntityFieldTypeDef;
};

export const DocEntityFieldTypeDefs: DocEntityFieldTypeDefTable = {
  verticalOffset: { entityType: "ENTITY_FIELD", id: "verticalOffset" },
  entityLevel: { entityType: "ENTITY_FIELD", id: "entityLevel" },
  entityType: { entityType: "ENTITY_FIELD", id: "entityType" },
};
